export const msToDays = (timeInMs) => {
    return Math.floor(timeInMs / (24*60*60*1000));
}

const getMsFromUnits = (val, units) => {
    // figure out the units from term1
    switch (units) {
        case "s":
        case "sec":
        case "secs":
        case "second":
        case "seconds":
            return val * 1000;
        case "min":
        case "mins":
        case "minute":
        case "minutes":
            return val * 60 * 1000;
        case "hr":
        case "hrs":
        case "hour":
        case "hours":
            return val * 60 * 60 * 1000;
        case "day":
        case "days":
            return val * 24 * 60 * 60 * 1000;
        default:
            return val;
    }
}

export const toMs = (x, units) => {
    if (typeof x === "string") {
        const terms = x.split(" ");
        const val = parseInt(terms[0], 10);
        if (isNaN(val)) {
            // it's not a number just return 0
            return 0;
        }
        if (terms.length === 1) {
            // only one term, just return the number as ms
            return val;
        }

        // figure out the units from term1
        return getMsFromUnits(val, terms[1])
    } else if ((typeof x === "number") && (typeof units === "string")) {
        return getMsFromUnits(x, units);
    }
}

export const utcToLocalTime = (utc) => {
    // convert a UTC formatted time string typically from mysql and convert it to local js date
    // expect YYYY-MM-DDTHH:MM:SS  no ms term
    const utcWithTZ = `${utc}.000Z`;
    return new Date(utcWithTZ);
}

export const toUtcDateString = (dt) => {
    const isoString = dt.toISOString();
    const terms = isoString.split("T");
    const timeTerms = terms[1].split(".");
    return `${terms[0]} ${timeTerms[0]}`;
}

export const toTimeString = (dt) => {
    const dateString = dt.toDateString();
    const timeString = dt.toTimeString().slice(0, 8);
    return (`${dateString} ${timeString}`);
}

export const toUtcDateStringShort = (dt) => {
    // return YYYY-MM-DD
    const isoString = dt.toISOString();
    const terms = isoString.split("T");
    return terms[0];
}